import { cn } from '@shared/utils/helpers';

import { ColumnConfiguration } from './DataTable.types';
import { DataTableColumnContents } from './DataTableColumnContents';
import { DataTableDeleteButton } from './DataTableDeleteButton';
import { DataTableEditButton } from './DataTableEditButton';
import { shouldFitContent, shouldRightAlign } from './helpers';

type DataTableRowProps<T> = {
  row: T;
  columns: ColumnConfiguration<T>[];
  refresh: () => void;
  editUrl?: string;
  onEdit?: () => void;
  onDelete?: () => void;
};

export function DataTableRow<T>({ row, columns, refresh, editUrl, onEdit, onDelete }: DataTableRowProps<T>) {
  const hasActions = Boolean(editUrl || onEdit || onDelete);

  return (
    <tr className="border-b">
      {columns.map((column, index) => (
        <td
          key={column.name || index}
          className={cn(
            'pl-4 first:pl-0 pr-4 last:pr-0 py-2',
            { 'min-w-fit w-0': shouldFitContent(column) },
            { 'text-right': shouldRightAlign(column) }
          )}
        >
          <DataTableColumnContents column={column} row={row} />
        </td>
      ))}
      {hasActions && (
        <td className={cn('pr-4 last:pr-0 py-2', 'min-w-fit w-0', 'text-right')}>
          <span className="inline-flex gap-2 pl-4 border-l border-dashed">
            {(editUrl || onEdit) && <DataTableEditButton editUrl={editUrl} onEdit={onEdit} />}
            {onDelete && <DataTableDeleteButton onDelete={onDelete} refresh={refresh} />}
          </span>
        </td>
      )}
    </tr>
  );
}
